<mib-modal size="lg" fullScreenOnPhone>
  <svg mib-modal-header mib-logo-medinbox class="h-6 text-mib-branding-900"></svg>

  <!-- `contents` makes both bands direct children of the modal's scrolling box: the tab bar stays put, only the markdown scrolls. -->
  <div mib-modal-content class="contents">
    <div class="shrink-0 flex not-expanded:flex-col text-gray-500 text-sm">
      @for (tab of tabs; track tab.file) {
        <div
          class="min-h-9 px-4 py-2 border-b not-expanded:border-b-0 not-expanded:border-l border-mib-divider cursor-pointer transition-colors flex items-center"
          [class.border-mib-primary]="currentTab() === tab.file"
          [class.border-b-2]="currentTab() === tab.file"
          [class.not-expanded:border-l-2]="currentTab() === tab.file"
          [class.text-mib-primary]="currentTab() === tab.file"
          (click)="selectTab(tab)">
          {{ tab.title }}
        </div>
      }
    </div>

    <!-- Bottom only: the top edge holds the pinned titles. -->
    <div
      #tabContent
      mibScrollFade
      mibScrollFadeEdges="bottom"
      class="mib-scrollbar overflow-y-auto min-h-0 flex-1 pr-4 mt-5">
      <markdown
        ngPreserveWhitespaces
        class="markdown"
        [src]="currentTab()"
        (error)="onError($event)"
        (ready)="onReady()">
      </markdown>
    </div>
  </div>
</mib-modal>
